<div class="modal-body width-600 height-800">
  <div class="layout-auto-1-auto">
    <span class="modal-header">{{getResource("HeaderText")}}
    </span>
    <div class="content">
      <div class="layout-auto-1-auto">
        <exg-search-bar (Search)="contactList.search($event)" [placeholder]="getResource('SearchPlaceholder')"
                        class="span-layout">

        </exg-search-bar>
        <div class="content">
          <exg-data-list (RowChange)="contactList.selectionChanged($event)"
                         [allowSingleSelection]="false" [displayState]="contactList.state"
                         [rowSource]="contactList.data"
                         [headerText]="getResource('Contact')"
                         [selectKey]="contactList.selectKey" [allowMultiSelection]="true" [selectSource]="contactList.selected"
                         (ItemSelect)="contactList.itemSelectionChanged($event)">
            <ng-template #rowTemplate let-row>
              <div class="grid-auto-1" style="padding:0.5rem">
                <div></div>
                <div>
                  <div>{{row.kontCaption}}</div>
                </div>
              </div>
            </ng-template>
          </exg-data-list>
        </div>
        <exg-pager (PageChange)="contactList.pageChanged($event)" *ngIf="!init"
                   [pagingSource]="contactList.paging"
                   class="span-layout">
          <ng-template #leftTemplate>
            <app-exg-dropdown *ngIf="data.type !== 1" [list]="[{caption:getResource('All'),value: true},{caption:getResource('InCase'),value: false}]"
                              position="abovecenter"
                              listdisplay="caption"
                              [label]="(contactList.showAll)? getResource('All'):getResource('InCase')"
                              (change)="contactList.showAll = $event.value.value;contactList.loadData()">
            </app-exg-dropdown>
          </ng-template>
        </exg-pager>
      </div>
    </div>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        {{getResource("ButtonClose")}}
      </button>
      <button (click)="save()" class="md-btn">
        {{getResource("ButtonChoose")}}
      </button>
    </div>
  </div>
</div>
